import { RegionShared } from "@1games-ru/region-shared";
import { OfferPaymentType } from "@1games-ru/region-shared/dist/enums/offer/offer";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";

export class OfferMpProvider {
  public static async resolve(
    uuid: string,
    accept: boolean,
    paymentType: OfferPaymentType = OfferPaymentType.NotProvided,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.OfferResolveResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.OfferResolveRequest,
      typeof RegionShared.Backend.Responses.OfferResolveResponse
    >(RegionShared.Backend.Events.Offer.OfferResolve, {
      accept,
      paymentType,
      uuid,
    });
  }

  public static async resolverShow(
    data: typeof RegionShared.Client.Requests.OfferResolverShowRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.OfferResolverShowResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.OfferResolverShowRequest,
      typeof RegionShared.Client.Responses.OfferResolverShowResponse
    >(RegionShared.Client.Events.Offer.OfferResolverShow, data);
  }

  public static async keep(
    uuid: string,
    seconds: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.OfferKeepResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.OfferKeepRequest,
      typeof RegionShared.Backend.Responses.OfferKeepResponse
    >(RegionShared.Backend.Events.Offer.OfferKeep, {
      uuid,
      seconds,
    });
  }
}
